module.exports = __webpack_public_path__ + "img/simple_ending_logo_icon_horizontal.175c7734.svg";